export var TransactionType;
(function (TransactionType) {
    TransactionType["REALISED"] = "realised";
    TransactionType["UNREALISED"] = "unrealised";
    TransactionType["TRANSACTION"] = "transaction";
})(TransactionType || (TransactionType = {}));
